module.exports = "/_next/static/images/e6d892c420772b0814a6b5853734de4b-roxinho-card-with-phone-md@3x.jpg.webp";